import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class AssetManager {
    // Category APIs
    categoryList(data) {
        return BaseService.post(APIPath.assetManagerCategoryList, data)
    }

    categoryGet(data) {
        return BaseService.post(APIPath.assetManagerCategoryGet, data)
    }

    categorySave(data) {
        return BaseService.post(APIPath.assetManagerCategorySave, data)
    }

    categoryDelete(data) {
        return BaseService.post(APIPath.assetManagerCategoryDelete, data)
    }

    // Location APIs
    locationList(data) {
        return BaseService.post(APIPath.assetManagerLocationList, data)
    }

    locationGet(data) {
        return BaseService.post(APIPath.assetManagerLocationGet, data)
    }

    locationSave(data) {
        return BaseService.post(APIPath.assetManagerLocationSave, data)
    }

    locationDelete(data) {
        return BaseService.post(APIPath.assetManagerLocationDelete, data)
    }

    // Asset APIs
    assetList(data) {
        return BaseService.post(APIPath.assetManagerAssetList, data)
    }

    assetGet(data) {
        return BaseService.post(APIPath.assetManagerAssetGet, data)
    }

    assetSave(data) {
        return BaseService.post(APIPath.assetManagerAssetSave, data)
    }

    assetDelete(data) {
        return BaseService.post(APIPath.assetManagerAssetDelete, data)
    }

    // Inspection APIs
    inspectionListByAsset(data) {
        return BaseService.post(APIPath.assetManagerInspectionListByAsset, data)
    }

    inspectionGet(data) {
        return BaseService.post(APIPath.assetManagerInspectionGet, data)
    }

    inspectionSave(data) {
        return BaseService.post(APIPath.assetManagerInspectionSave, data)
    }

    inspectionDelete(data) {
        return BaseService.post(APIPath.assetManagerInspectionDelete, data)
    }

    // InspectionItem APIs
    inspectionItemList(data) {
        return BaseService.post(APIPath.assetManagerInspectionItemList, data)
    }

    inspectionItemSave(data) {
        return BaseService.post(APIPath.assetManagerInspectionItemSave, data)
    }

    inspectionItemDeleteByInspection(data) {
        return BaseService.post(APIPath.assetManagerInspectionItemDeleteByInspection, data)
    }

    // InspectionMedia APIs
    inspectionMediaList(data) {
        return BaseService.post(APIPath.assetManagerInspectionMediaList, data)
    }

    inspectionMediaSave(data) {
        return BaseService.post(APIPath.assetManagerInspectionMediaSave, data)
    }

    inspectionMediaDelete(data) {
        return BaseService.post(APIPath.assetManagerInspectionMediaDelete, data)
    }

    /**
     * Create or update link between an asset and an inspection (EAUDITOR-486).
     * Payload shape TBD from backend.
     */
    assetAuditLinkSave(data) {
        return BaseService.post(APIPath.assetManagerAssetAuditLinkSave, data)
    }

    /**
     * Inspection history for an asset (EAUDITOR-487).
     * Payload shape TBD from backend.
     */
    assetInspectionHistory(data) {
        return BaseService.post(APIPath.assetManagerAssetInspectionHistory, data)
    }
}

const AssetManagerService = new AssetManager()
Object.freeze(AssetManagerService)
export { AssetManagerService }
